import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import j25Ratings from "../../../../src/data/articles/cube-prospective-foundations-jumpstart/j25-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  j25Ratings,
  ProspectiveIntro,
  React
};